export const state = () => ({
  selectedVerificationType: '',
  documentType: '',
})

export const mutations = {
  SET_VERIFICATION_TYPE(state, type) {
    state.selectedVerificationType = type
  },
  SET_DOCUMENT_TYPE(state, type) {
    state.documentType = type
  },
}

export const actions = {
  async SELECT_VERIFICATION_TYPE({ commit }, data) {
    commit('SET_VERIFICATION_TYPE', data)
  },
  async SELECT_DOCUMENT_TYPE({ commit }, data) {
    commit('SET_DOCUMENT_TYPE', data)
  },
}

export const getters = {
  GET_SELECTED_VERIFICATION_TYPE: state => state.selectedVerificationType,
  GET_SELECTED_DOCUMENT_TYPE: state => state.documentType,
}
